import { render, staticRenderFns } from "./EmployeeProficiencyView.vue?vue&type=template&id=3145bddd&"
import script from "./EmployeeProficiencyView.vue?vue&type=script&lang=js&"
export * from "./EmployeeProficiencyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports